export type TranslationKey =
  | 'account.yourAccountSettings'
  | 'account.firstName'
  | 'account.lastName'
  | 'account.email'
  | 'account.password'
  | 'account.role'
  | 'account.resetPassword'
  | 'account.editInfo'
  | 'account.resetPasswordConfirmation'
  | 'account.login.emailRequired'
  | 'account.passwordRequired'
  | 'account.resetPassword.subject'
  | 'account.resetPassword.message'
  | 'account.newAccountResetPassword.subject'
  | 'account.newAccountResetPassword.message'
  | 'account.verificationEmailSent'
  | 'account.emailVerificationFailed'
  | 'account.emailVerificationSuccess'
  | 'account.verifyEmailExtra'
  | 'account.login.privacyBanner.title'
  | 'account.login.privacyBanner.body'
  | 'account.login.privacyBanner.privacyPolicy'
  | 'carrier_account.fulfillmentContextsHelper'
  | 'carrier_account.hazmatLimitedQuantityExemptHelper'
  | 'carrier_account.accountFormNameHelper'
  | 'carrier_account.accountFormNameValidate'
  | 'carrier_account.accountFormPeakHelper'
  | 'carrier_account.accountFormFCHelper'
  | 'carrier_account.accountFormFCValidation'
  | 'carrier_account.accountFormTitle'
  | 'carrier_account.accountName'
  | 'carrier_account.carrier'
  | 'carrier_account.carrierValidation'
  | 'carrier_account.peakSurchargeEligible'
  | 'carrier_account.peakSurchargeExclusions'
  | 'carrier_account.allowLabelGenerationFailover'
  | 'carrier_account.accountFormLabelGenerationHelper'
  | 'carrier_account.testMode'
  | 'carrier_account.accountFCLabel'
  | 'carrier_account.contactInformation'
  | 'carrier_account.shipperAddress'
  | 'carrier_account.delete_account_warning'
  | 'carrier_account.delete_service_method_warning'
  | 'carrier_account.delete_service_method_param_warning'
  | 'common.delete'
  | 'common.fastIsPossible'
  | 'common.logout'
  | 'common.login'
  | 'common.submit'
  | 'common.next'
  | 'common.email'
  | 'common.previous'
  | 'common.register'
  | 'common.forgotPassword'
  | 'common.sso'
  | 'common.true'
  | 'common.false'
  | 'exception_management.last_update'
  | 'exception_management.exception_detected'
  | 'exception_management.exception_type'
  | 'exception_management.status'
  | 'exception_management.owner'
  | 'exception_management.page_description'
  | 'exception_management.modify'
  | 'exception_management.mark_resolved'
  | 'exception_management.change_exception_status'
  | 'exception_management.reassign'
  | 'exception_management.exception_types.NOT_FC_COMPLETE_IN_SLA'
  | 'exception_management.exception_types.NOT_DELIVERED_IN_SLA'
  | 'exception_management.addressed'
  | 'exception_management.detected'
  | 'exception_management.claimed'
  | 'exception_management.actions'
  | 'fulfillment.config.title'
  | 'fulfillment.config.addFC'
  | 'fulfillment.config.fcInfo'
  | 'fulfillment.config.shipDays'
  | 'fulfillment.config.contact'
  | 'fulfillment.config.holidayHelperMessage'
  | 'fulfillment.config.processingDays'
  | 'fulfillment.config.holidays'
  | 'fulfillment.config.shippingCapabilities'
  | 'fulfillment.config.sameDayShippingDescription'
  | 'fulfillment.config.nextDayShippingDescription'
  | 'fulfillment.config.sameDayShippingLabel'
  | 'fulfillment.config.nextDayShippingLabel'
  | 'fulfillment.config.cutOffTime'
  | 'fulfillment.config.customShipCapabilitiesDescription'
  | 'fulfillment.config.nextButtonWarning'
  | 'fulfillment.config.cutOffTimeRequired'
  | 'fulfillment.config.nextButtonAllowed'
  | 'layout.header.accountDropdownTitle'
  | 'layout.notifications.clearNotifications'
  | 'layout.footer.copyright'
  | 'label.FCLabelDpiHelp'
  | 'label.FCLabelSizeHelp'
  | 'label.confirmAugmentationDelete'
  | 'label.noFCsConfigured'
  | 'partner.config.volumeEstimates.title'
  | 'partner.config.volumeEstimates.description'
  | 'partner.config.volumeEstimates.weeklyAvg.label'
  | 'partner.config.volumeEstimates.weeklyPeak.label'
  | 'partner.config.volumeEstimates.dailyAvg.label'
  | 'partner.config.volumeEstimates.dailyPeak.label'
  | 'partner.config.volumeEstimates.hourlyAvg.label'
  | 'partner.config.volumeEstimates.hourlyPeak.label'
  | 'partner.config.volumeEstimates.weeklyAvg.description'
  | 'partner.config.volumeEstimates.weeklyPeak.description'
  | 'partner.config.volumeEstimates.dailyAvg.description'
  | 'partner.config.volumeEstimates.dailyPeak.description'
  | 'partner.config.volumeEstimates.hourlyAvg.description'
  | 'partner.config.volumeEstimates.hourlyPeak.description'
  | 'partner.config.reportingConfiguration.title'
  | 'partner.config.reportingConfiguration.description'
  | 'partner.config.reportingTimezone.label'
  | 'partner.config.reportingTimezone.description'
  | 'partner.config.reportingConfiguration.startOfWeek.label'
  | 'partner.config.reportingConfiguration.startOfWeek.description'
  | 'partner.config.reportingConfiguration.orderToShipSlaDays.label'
  | 'partner.config.reportingConfiguration.orderToShipSlaDays.description'
  | 'partner.config.reportingConfiguration.orderToDeliverSlaDays.label'
  | 'partner.config.reportingConfiguration.orderToDeliverSlaDays.description'
  | 'partner.config.cancel'
  | 'partner.config.save'
  | 'partner.config.reportingConfiguration.successMessage'
  | 'partner.config.reportingConfiguration.errorMessage'
  | 'partner.config.volumeEstimates.successMessage'
  | 'partner.config.volumeEstimates.errorMessage'
  | 'registration.userRegistration'
  | 'registration.partnerSetup'
  | 'registration.confirmPassword'
  | 'registration.registrationSuccess.title'
  | 'registration.registrationSuccess.subTitle'
  | 'registration.validation.emailRequired'
  | 'registration.validation.firstNameRequired'
  | 'registration.validation.lastNameRequired'
  | 'registration.validation.passwordRequired'
  | 'registration.validation.passwordComplexity'
  | 'registration.validation.passwordEmailVerify'
  | 'registration.validation.passwordASCII'
  | 'registration.validation.passwordMaxComplexity'
  | 'registration.validation.passwordMismatch'
  | 'registration.firstName'
  | 'registration.lastName'
  | 'registration.password'
  | 'registration.validation.partnerNameRequired'
  | 'registration.partnerName'
  | 'registration.country'
  | 'registration.partnerType'
  | 'registration.returnToLogin'
  | 'registration.changePassword'
  | 'registration.expiredChangePasswordLink'
  | 'registration.resetPassword'
  | 'registration.passwordResetEmailSent'
  | 'registration.passwordExpired'
  | 'reports.withinSLA'
  | 'reports.smallSLAMiss'
  | 'reports.mediumSLAMiss'
  | 'reports.largeSLAMiss'
  | 'reports.performance'
  | 'reports.orderCount'
  | 'reports.orderPercentage'
  | 'reports.orderToShip'
  | 'reports.orderToDeliver'
  | 'reports.shipToDeliver'
  | 'reports.dateStartHelp'
  | 'reports.dateEndHelp'
  | 'reports.dateAggregatorHelp'
  | 'reports.fcSelectHelp'
  | 'reports.editParamsStep'
  | 'reports.selectDateRange'
  | 'reports.selectFC'
  | 'reports.allFCs'
  | 'reports.customRange'
  | 'reports.datePresets.yesterday'
  | 'reports.datePresets.weekToDate'
  | 'reports.datePresets.pastWeek'
  | 'reports.datePresets.previousWeek'
  | 'reports.datePresets.monthToDate'
  | 'reports.datePresets.pastMonth'
  | 'reports.datePresets.previousMonth'
  | 'reports.datePresets.pastYear'
  | 'reports.datePresets.previousYear'
  | 'reports.datePresets.yearToDate'
  | 'reports.datePresets.customRange'
  | 'reports.hour'
  | 'reports.day'
  | 'reports.week'
  | 'reports.month'
  | 'reports.year'
  | 'restriction.box'
  | 'restriction.envelope'
  | 'restriction.max_combined'
  | 'restriction.max_length'
  | 'restriction.in'
  | 'restriction.cm'
  | 'restriction.max'
  | 'restriction.lb'
  | 'restriction.kg'
  | 'restriction.weight_title'
  | 'restriction.dimension_title'
  | 'restriction.must_have'
  | 'restriction.have_a'
  | 'restriction.weight_of'
  | 'restriction.less_than'
  | 'security.accessKeyName'
  | 'security.oauthClientName'
  | 'security.oauthClientId'
  | 'security.resetAccessKey'
  | 'serurity.resetClient'
  | 'sercurity.createClient'
  | 'security.created'
  | 'security.accessKeyName'
  | 'security.accessKeyId'
  | 'security.active'
  | 'security.reset'
  | 'security.resetAccessKey'
  | 'security.activateSwitch'
  | 'security.configureKeys'
  | 'security.createKey'
  | 'security.keyName'
  | 'security.clientName'
  | 'security.create'
  | 'security.createClient'
  | 'security.secretWarning'
  | 'securtiy.oauthCreationMessage'
  | 'security.keyCreationMessage'
  | 'security.okMessage'
  | 'security.resetWarning'
  | 'security.resetButtonMessage'
  | 'security.resetKeyMessage'
  | 'security.deactivateKey'
  | 'security.reactivateKey'
  | 'security.deactivateClient'
  | 'security.reactivateClient'
  | 'security.resetClientMessage'
  | 'security.keyWarning'
  | 'security.clientName'
  | 'securtiy.oauthCreationMessage'
  | 'security.keyCreationMessage'
  | 'security.configuredClients'
  | 'shipium_terms.administrator.description'
  | 'shipium_terms.administrator.term'
  | 'shipium_terms.editor.description'
  | 'shipium_terms.editor.term'
  | 'shipium_terms.viewer.description'
  | 'shipium_terms.viewer.term'
  | 'shipium_terms.site_manager.description'
  | 'shipium_terms.site_manager.term'
  | 'shipium_terms.site_associate.description'
  | 'shipium_terms.site_associate.term'
  | 'tracking.tableColumns.carrierStatusMessage'
  | 'tracking.tableColumns.eventDateTime'
  | 'tracking.tableColumns.deliveryStep'
  | 'tracking.tableColumns.eventCity'
  | 'tracking.tableColumns.eventRegion'
  | 'tracking.tableColumns.eventPostalCode'
  | 'tracking.tableColumns.status'
  | 'tracking.tableColumns.trackingId'
  | 'tracking.tableColumns.shippedDateTime'
  | 'tracking.tableColumns.carrierServiceMethod'
  | 'tracking.tableColumns.estimatedDeliveryDateTime'
  | 'tracking.tableColumns.labelPrintedDateTime'
  | 'tracking.tableColumns.deliveredDateTime'
  | 'tracking.getTrackingForm.carrierName'
  | 'tracking.getTrackingForm.title'
  | 'tracking.getTrackingForm.idListLabel'
  | 'tracking.getTrackingForm.idListExtra'
  | 'tracking.getTrackingForm.idListError'
  | 'tracking.selectTrackingMessage'
  | 'tracking.selectDifferentTrackingMessage'
  | 'tracking.noSelectedTracking'
  | 'tracking.viewDetails'
  | 'partner.packaging.helpReformatMessage';

export const defaultTranslations: Record<TranslationKey, string> = {
  'account.yourAccountSettings': '',
  'account.firstName': '',
  'account.lastName': '',
  'account.email': '',
  'account.password': '',
  'account.role': '',
  'account.resetPassword': '',
  'account.editInfo': '',
  'account.resetPasswordConfirmation': '',
  'account.login.emailRequired': '',
  'account.passwordRequired': '',
  'account.resetPassword.subject': '',
  'account.resetPassword.message': '',
  'account.newAccountResetPassword.subject': '',
  'account.newAccountResetPassword.message': '',
  'account.verificationEmailSent': '',
  'account.emailVerificationFailed': '',
  'account.emailVerificationSuccess': '',
  'account.verifyEmailExtra': '',
  'account.login.privacyBanner.title': '',
  'account.login.privacyBanner.body': '',
  'account.login.privacyBanner.privacyPolicy': '',
  'carrier_account.fulfillmentContextsHelper': '',
  'carrier_account.hazmatLimitedQuantityExemptHelper': '',
  'carrier_account.accountFormNameHelper': '',
  'carrier_account.accountFormNameValidate': '',
  'carrier_account.accountFormPeakHelper': ``,
  'carrier_account.accountFormFCHelper': ``,
  'carrier_account.accountFormFCValidation': '',
  'carrier_account.accountFormTitle': '',
  'carrier_account.accountName': '',
  'carrier_account.carrier': '',
  'carrier_account.carrierValidation': '',
  'carrier_account.delete_account_warning': '',
  'carrier_account.delete_service_method_warning': '',
  'carrier_account.delete_service_method_param_warning': '',
  'carrier_account.peakSurchargeEligible': '',
  'carrier_account.accountFCLabel': '',
  'carrier_account.contactInformation': '',
  'carrier_account.shipperAddress': '',
  'common.delete': '',
  'carrier_account.peakSurchargeExclusions': '',
  'carrier_account.allowLabelGenerationFailover': '',
  'carrier_account.accountFormLabelGenerationHelper': '',
  'carrier_account.testMode': '',
  'common.fastIsPossible': '',
  'common.logout': '',
  'common.login': '',
  'common.submit': '',
  'common.next': '',
  'common.previous': '',
  'common.register': '',
  'common.email': '',
  'common.false': '',
  'common.true': '',
  'common.forgotPassword': '',
  'common.sso': '',
  'exception_management.last_update': '',
  'exception_management.exception_detected': '',
  'exception_management.exception_type': '',
  'exception_management.status': '',
  'exception_management.owner': '',
  'exception_management.page_description': '',
  'exception_management.modify': '',
  'exception_management.mark_resolved': '',
  'exception_management.change_exception_status': '',
  'exception_management.reassign': '',
  'exception_management.exception_types.NOT_FC_COMPLETE_IN_SLA': '',
  'exception_management.exception_types.NOT_DELIVERED_IN_SLA': '',
  'exception_management.addressed': '',
  'exception_management.detected': '',
  'exception_management.claimed': '',
  'exception_management.actions': '',
  'fulfillment.config.title': '',
  'fulfillment.config.addFC': '',
  'fulfillment.config.fcInfo': '',
  'fulfillment.config.shipDays': '',
  'fulfillment.config.contact': '',
  'fulfillment.config.processingDays': '',
  'fulfillment.config.holidays': '',
  'fulfillment.config.shippingCapabilities': '',
  'fulfillment.config.sameDayShippingDescription': '',
  'fulfillment.config.nextDayShippingDescription': '',
  'fulfillment.config.sameDayShippingLabel': '',
  'fulfillment.config.nextDayShippingLabel': '',
  'fulfillment.config.cutOffTime': '',
  'fulfillment.config.customShipCapabilitiesDescription': '',
  'fulfillment.config.nextButtonWarning': '',
  'fulfillment.config.cutOffTimeRequired': '',
  'fulfillment.config.nextButtonAllowed': '',
  'layout.header.accountDropdownTitle': '',
  'layout.notifications.clearNotifications': '',
  'layout.footer.copyright': '',
  'label.FCLabelDpiHelp': '',
  'label.FCLabelSizeHelp': '',
  'label.confirmAugmentationDelete': '',
  'label.noFCsConfigured': '',
  'partner.config.volumeEstimates.title': '',
  'partner.config.volumeEstimates.description': '',
  'partner.config.volumeEstimates.weeklyAvg.label': '',
  'partner.config.volumeEstimates.weeklyPeak.label': '',
  'partner.config.volumeEstimates.dailyAvg.label': '',
  'partner.config.volumeEstimates.dailyPeak.label': '',
  'partner.config.volumeEstimates.hourlyAvg.label': '',
  'partner.config.volumeEstimates.hourlyPeak.label': '',
  'partner.config.volumeEstimates.weeklyAvg.description': '',
  'partner.config.volumeEstimates.weeklyPeak.description': '',
  'partner.config.volumeEstimates.dailyAvg.description': '',
  'partner.config.volumeEstimates.dailyPeak.description': '',
  'partner.config.volumeEstimates.hourlyAvg.description': '',
  'partner.config.volumeEstimates.hourlyPeak.description': '',
  'partner.config.reportingConfiguration.title': '',
  'partner.config.reportingConfiguration.description': '',
  'partner.config.reportingTimezone.label': '',
  'partner.config.reportingTimezone.description': '',
  'partner.config.reportingConfiguration.startOfWeek.label': '',
  'partner.config.reportingConfiguration.startOfWeek.description': '',
  'partner.config.reportingConfiguration.orderToShipSlaDays.label': '',
  'partner.config.reportingConfiguration.orderToShipSlaDays.description': '',
  'partner.config.reportingConfiguration.orderToDeliverSlaDays.label': '',
  'partner.config.reportingConfiguration.orderToDeliverSlaDays.description': '',
  'partner.config.cancel': '',
  'partner.config.save': '',
  'partner.config.reportingConfiguration.successMessage': '',
  'partner.config.reportingConfiguration.errorMessage': '',
  'partner.config.volumeEstimates.successMessage': '',
  'partner.config.volumeEstimates.errorMessage': '',
  'registration.userRegistration': '',
  'registration.partnerSetup': '',
  'registration.confirmPassword': '',
  'registration.registrationSuccess.title': '',
  'registration.registrationSuccess.subTitle': '',
  'registration.validation.emailRequired': '',
  'registration.validation.firstNameRequired': '',
  'registration.validation.lastNameRequired': '',
  'registration.validation.passwordRequired': '',
  'registration.validation.passwordComplexity': '',
  'registration.validation.passwordEmailVerify': '',
  'registration.validation.passwordASCII': '',
  'registration.validation.passwordMaxComplexity': '',
  'registration.validation.passwordMismatch': '',
  'registration.firstName': '',
  'registration.lastName': '',
  'registration.password': '',
  'registration.validation.partnerNameRequired': '',
  'registration.partnerName': '',
  'registration.country': '',
  'registration.partnerType': '',
  'registration.returnToLogin': '',
  'registration.changePassword': '',
  'registration.expiredChangePasswordLink': '',
  'registration.resetPassword': '',
  'registration.passwordResetEmailSent': '',
  'registration.passwordExpired': '',
  'reports.withinSLA': '',
  'reports.smallSLAMiss': '',
  'reports.mediumSLAMiss': '',
  'reports.largeSLAMiss': '',
  'reports.performance': '',
  'reports.orderCount': '',
  'reports.orderPercentage': '',
  'reports.orderToShip': '',
  'reports.orderToDeliver': '',
  'reports.shipToDeliver': '',
  'reports.dateStartHelp': '',
  'reports.dateEndHelp': '',
  'reports.dateAggregatorHelp': '',
  'reports.fcSelectHelp': '',
  'reports.editParamsStep': '',
  'reports.selectDateRange': '',
  'reports.selectFC': '',
  'reports.allFCs': '',
  'reports.customRange': '',
  'reports.datePresets.yesterday': '',
  'reports.datePresets.weekToDate': '',
  'reports.datePresets.pastWeek': '',
  'reports.datePresets.previousWeek': '',
  'reports.datePresets.monthToDate': '',
  'reports.datePresets.pastMonth': '',
  'reports.datePresets.previousMonth': '',
  'reports.datePresets.pastYear': '',
  'reports.datePresets.previousYear': '',
  'reports.datePresets.yearToDate': '',
  'reports.datePresets.customRange': '',
  'reports.hour': '',
  'reports.day': '',
  'reports.week': '',
  'reports.month': '',
  'reports.year': '',
  'restriction.box': '',
  'restriction.envelope': '',
  'restriction.max_combined': '',
  'restriction.max_length': '',
  'restriction.in': '',
  'restriction.cm': '',
  'restriction.max': '',
  'restriction.lb': '',
  'restriction.kg': '',
  'restriction.weight_title': '',
  'restriction.dimension_title': '',
  'restriction.must_have': '',
  'restriction.have_a': '',
  'restriction.weight_of': '',
  'restriction.less_than': '',
  'security.accessKeyName': '',
  'security.configuredClients': '',
  'security.oauthClientName': '',
  'security.oauthClientId': '',
  'security.resetAccessKey': '',
  'serurity.resetClient': '',
  'sercurity.createClient': '',
  'security.created': '',
  'security.accessKeyId': '',
  'security.active': '',
  'security.reset': '',
  'security.activateSwitch': '',
  'security.configureKeys': '',
  'security.createKey': '',
  'security.keyName': '',
  'security.clientName': '',
  'security.create': '',
  'security.createClient': '',
  'security.secretWarning': '',
  'securtiy.oauthCreationMessage': '',
  'security.keyCreationMessage': '',
  'security.okMessage': '',
  'security.resetWarning': '',
  'security.resetButtonMessage': '',
  'security.resetKeyMessage': '',
  'security.deactivateKey': '',
  'security.reactivateKey': '',
  'security.deactivateClient': '',
  'security.reactivateClient': '',
  'security.resetClientMessage': '',
  'security.keyWarning': '',
  'shipium_terms.administrator.description': '',
  'shipium_terms.administrator.term': '',
  'shipium_terms.editor.description': '',
  'shipium_terms.editor.term': '',
  'shipium_terms.viewer.description': '',
  'shipium_terms.viewer.term': '',
  'shipium_terms.site_manager.description': '',
  'shipium_terms.site_manager.term': '',
  'shipium_terms.site_associate.description': '',
  'shipium_terms.site_associate.term': '',
  'tracking.tableColumns.carrierStatusMessage': '',
  'tracking.tableColumns.eventDateTime': '',
  'tracking.tableColumns.deliveryStep': '',
  'tracking.tableColumns.eventCity': '',
  'tracking.tableColumns.eventRegion': '',
  'tracking.tableColumns.eventPostalCode': '',
  'tracking.tableColumns.status': '',
  'tracking.tableColumns.trackingId': '',
  'tracking.tableColumns.shippedDateTime': '',
  'tracking.tableColumns.deliveredDateTime': '',
  'tracking.tableColumns.carrierServiceMethod': '',
  'tracking.tableColumns.estimatedDeliveryDateTime': '',
  'tracking.tableColumns.labelPrintedDateTime': '',
  'tracking.getTrackingForm.carrierName': '',
  'tracking.getTrackingForm.title': '',
  'tracking.getTrackingForm.idListLabel': '',
  'tracking.getTrackingForm.idListExtra': '',
  'tracking.getTrackingForm.idListError': '',
  'tracking.selectTrackingMessage': '',
  'tracking.selectDifferentTrackingMessage': '',
  'tracking.noSelectedTracking': '',
  'tracking.viewDetails': '',
  'fulfillment.config.holidayHelperMessage': '',
  'partner.packaging.helpReformatMessage': '',
};
